import { MinutePageHeader } from 'components/minute/layout/MinutePageHeader';
import { MinutePageTitle } from 'components/minute/layout/MinutePageTitle';
import { VerifyEmailPageContent } from 'components/site/pages/VerifyEmailPageContent';
import CSS from 'csstype';
import { MinuteWhiteBg } from 'pages/minute/shared/MinuteWhiteBg';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export interface IProps {
    style?: CSS.Properties;
    className?: string;
}

export const VerifyEmailPage = (): JSX.Element => {
    return (
        <S_VerifyEmailPage>
            <S_Center>
                <MinutePageHeader />
                <MinutePageTitle
                    title={Localization.EMAIL_VERIFIED}
                    subtitle={Localization.EMAIL_VERIFIED_DESC}
                />

                <VerifyEmailPageContent />
            </S_Center>
            <MinuteWhiteBg />
        </S_VerifyEmailPage>
    );
};

const S_VerifyEmailPage = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
`;

const S_Center = styled.div`
    display: flex;
    width: 1260px;
    margin: 40px 0 0 0;
    flex-direction: column;
    z-index: 1;
`;
